export default {
  name: 'mobile-menu',
  computed: {
    show: {
      get() {
        return this.$store.getters['layout/showMobileMenu'];
      },
      set(value) {
        this.$store.dispatch('layout/toggleMenu', value);
      },
    },
  },

};
